import * as tslib_1 from "tslib";
import { DateTime } from 'luxon';
import { Model } from '@app/models/model';
var User = /** @class */ (function (_super) {
    tslib_1.__extends(User, _super);
    function User(input) {
        var _this = _super.call(this, input) || this;
        _this.formatName();
        _this.formatSignup();
        return _this;
    }
    User.prototype.formatName = function () {
        this.name = this.first_name + ' ' + this.last_name;
    };
    User.prototype.formatSignup = function () {
        this.signup = DateTime.fromISO(this.signup_datetime).toLocaleString(DateTime.DATETIME_MED);
    };
    return User;
}(Model));
export { User };
